export enum CrudActions {
    Create = "create",
    Read = "read",
    Update = "update",
    Destroy = "destroy",
}
